<template>
  <div v-if="showBanner" class="cookie-message">
    <div class="container">
      <div class="text">
        <p>
          We use first and third party cookies to improve your experience on our
          website. By browsing this website, you agree to our use of cookies.
        </p>
      </div>
      <div class="button-group">
        <Button theme="outline" @click="declineCookies">Reject</Button>
        <Button @click="acceptCookies">Accept and continue</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "CookieMessage",
  components: {
    Button,
  },
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    // Check localStorage for existing consent preference
    const savedConsent = localStorage.getItem("cookieConsent");
    if (savedConsent) {
      // If user has already made a choice, don't show banner
      this.showBanner = false;
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error) {
          throw error;
        }

        this.initCookieBanner();
      }
    );
  },
  methods: {
    areVisitorConsentsEmpty(consents) {
      for (let key in consents) {
        if (Object.prototype.hasOwnProperty.call(consents, key)) {
          if (consents[key] !== "") {
            return false;
          }
        }
      }
      return true;
    },
    initCookieBanner() {
      const currentVisitorConsent =
        window.Shopify.customerPrivacy.currentVisitorConsent();

      const visitorConsentsEmpty = this.areVisitorConsentsEmpty(
        currentVisitorConsent
      );
      const shouldShowBanner =
        window.Shopify.customerPrivacy.shouldShowBanner();

      if (shouldShowBanner && visitorConsentsEmpty) {
        this.showBanner = true;
      }
    },
    declineCookies() {
      // Store rejection in localStorage
      const consentData = {
        marketing: false,
        analytics: false,
        preferences: false,
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem("cookieConsent", JSON.stringify(consentData));

      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          marketing: false,
          analytics: false,
          preferences: false,
          headlessStorefront: true,
          checkoutRootDomain: process.env.SHOPIFY_SSO_STORE_URL,
          storefrontRootDomain: process.env.SHOPIFY_SSO_STORE_URL,
          storefrontAccessToken: process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        () => {
          this.showBanner = false;
        }
      );
    },
    acceptCookies() {
      // Store acceptance in localStorage
      const consentData = {
        marketing: true,
        analytics: true,
        preferences: true,
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem("cookieConsent", JSON.stringify(consentData));

      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          marketing: true,
          analytics: true,
          preferences: true,
          headlessStorefront: true,
          checkoutRootDomain: process.env.SHOPIFY_SSO_STORE_URL,
          storefrontRootDomain: process.env.SHOPIFY_SSO_STORE_URL,
          storefrontAccessToken: process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        },
        (error) => {
          if (error) {
            console.error("error", error);
          }
          this.showBanner = false;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-message {
  background-color: $color-white;
  padding: 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 10px 10px 10px rgba(black, 0.2);

  .container {
    @include respond-above(md) {
      display: flex;
      gap: 20px;
      justify-content: center;
      align-items: center;
    }
  }

  .text {
    margin-bottom: 20px;
    @include t__editorial-body-10;

    @include respond-above(md) {
      margin-bottom: 0;
    }
  }

  .button-group {
    display: flex;

    @include respond-above(md) {
      flex: 0 0 auto;
      display: block;
    }

    .button {
      flex: 1 1 auto;
      font-family: $utility-font-family;
      font-weight: 400;
      letter-spacing: 0.5px;
    }

    .button + .button {
      margin-left: 10px;
    }
  }
}
</style>
